import { render, staticRenderFns } from "./Sponsor.vue?vue&type=template&id=f66f4722&scoped=true"
import script from "./Sponsor.vue?vue&type=script&lang=js"
export * from "./Sponsor.vue?vue&type=script&lang=js"
import style0 from "../assets/styles/checkBoxInput.css?vue&type=style&index=0&id=f66f4722&prod&scoped=true&lang=css&external"
import style1 from "./Sponsor.vue?vue&type=style&index=1&id=f66f4722&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f66f4722",
  null
  
)

export default component.exports